import styles from './message.scss';
import { rm } from 'utils';

export const Message = () => <p className={styles.message}>{rm('no_articles_message')}</p>;
